import React, { useState } from "react";
import { showToast } from "../common/Toast";
import "./TicketForm.css";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const TicketForm = ({ onTicketCreated }) => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    priority: "Medium",
  });
  const [loading, setLoading] = useState(false);
  const priorities = ["Low", "Medium", "High"];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title.trim() || !formData.description.trim()) {
      showToast.error("Please fill in all required fields");
      return;
    }

    setLoading(true);

    try {
      const token = localStorage.getItem("authToken");

      if (!token) {
        showToast.error("Please login again");
        window.location.href = "/login";
        return;
      }

      console.log(
        "🔑 Sending request with token:",
        token.substring(0, 20) + "...",
      );
      console.log("📦 Request data:", {
        title: formData.title.trim(),
        description: formData.description.trim(),
        priority: formData.priority,
      });

      const response = await fetch(`${API_URL}/tickets`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          title: formData.title.trim(),
          description: formData.description.trim(),
          priority: formData.priority,
        }),
      });

      const data = await response.json();
      console.log("📥 Server response:", data);

      // ✅ SHOW THE ACTUAL ERROR MESSAGE
      if (!response.ok) {
        // Check if there are validation errors
        if (data.errors && data.errors.length > 0) {
          const errorMessage =
            data.errors[0].msg || data.errors[0].message || "Validation failed";
          console.log("❌ Validation error:", data.errors[0]);
          throw new Error(errorMessage);
        }
        throw new Error(data.message || "Failed to create ticket");
      }

      setFormData({
        title: "",
        description: "",
        priority: "Medium",
      });

      showToast.success("Ticket created successfully!");

      if (onTicketCreated) {
        onTicketCreated(data.data);
      }
    } catch (error) {
      console.error("❌ Error:", error);
      // ✅ SHOW THE SPECIFIC ERROR MESSAGE
      showToast.error(error.message || "Failed to create ticket");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ticket-form-container">
      <h3>Create New Ticket</h3>

      <form onSubmit={handleSubmit} className="ticket-form">
        <div className="form-group">
          <label htmlFor="title">
            Title <span className="required">*</span>
          </label>
          <input
            type="text"
            id="title"
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="Brief description of the issue"
            disabled={loading}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="description">
            Description <span className="required">*</span>
          </label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Detailed description of the problem"
            rows="4"
            disabled={loading}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="priority">
            Priority <span className="required">*</span>
          </label>
          <select
            id="priority"
            name="priority"
            value={formData.priority}
            onChange={handleChange}
            disabled={loading}
          >
            {priorities.map((priority) => (
              <option key={priority} value={priority}>
                {priority}
              </option>
            ))}
          </select>
        </div>

        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? "Creating Ticket..." : "Submit Ticket"}
        </button>
      </form>
    </div>
  );
};

export default TicketForm;
